import React from "react";
import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react";

export const TransactionTypeIcon = ({ isWithdrawal, size = "h-5 w-5" }) => (
  <div
    className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${
      isWithdrawal ? "bg-amber-100" : "bg-blue-100"
    }`}
  >
    {isWithdrawal ? (
      <ArrowUpFromLine className={`${size} text-amber-600`} />
    ) : (
      <ArrowDownToLine className={`${size} text-blue-600`} />
    )}
  </div>
);
